import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * Icon wrapper component for Lucide React icons
 * 
 * @param {string} name - The name of the Lucide icon (e.g., 'Home', 'User', 'Settings')
 * @param {number} size - Size of the icon (default: 20)
 * @param {string} color - Color of the icon (default: 'currentColor')
 * @param {number} strokeWidth - Stroke width of the icon (default: 2)
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional props to pass to the icon
 */
const Icon = ({ 
  name, 
  size = 20, 
  color = 'currentColor', 
  strokeWidth = 2, 
  className = '',
  ...props 
}) => {
  const IconComponent = LucideIcons[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in Lucide React`);
    return null;
  }
  
  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={`lucide-icon ${className}`}
      {...props}
    />
  );
};

export default Icon;

export const ICON_MAPPINGS = {
  // Custom TamTam icons
  'icon-tt-menu': 'Menu',
  'icon-tt-close': 'X',
  'icon-tt-magnifier': 'Search',
  'icon-tt-facebook': 'Facebook',
  'icon-tt-linkedin': 'Linkedin',
  'icon-tt-instagram': 'Instagram',
  'icon-tt-contact': 'Mail',
};
